import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper/bundle";

const templateVideoGallery = {
  init: function () {
    templateVideoGallery.video();
    templateVideoGallery.slider();
  },

  video: function () {
    $(".video__play").on("click", function () {
      let $clickedButton = $(this);
      $clickedButton.fadeOut(250);

      let $videoContainer = $clickedButton.closest(".video");
      let $videoContent = $videoContainer.find(".video__content");

      if (
        $videoContent.length > 0 &&
        $videoContent[0] instanceof HTMLVideoElement
      ) {
        new LazyLoad({
          elements_selector: ".video__content",
        });

        setTimeout(function () {
          $videoContent.addClass("video__content--active")[0].play();
        }, 250);
      } else {
        console.error("Video element not found or invalid.");
      }
    });
  },

  closeAllVideos: function () {
    $(".video__content").each(function () {
      let $activeVideo = $(this);
      let $videoContainer = $activeVideo.closest(".video");
      let $playButton = $videoContainer.find(".video__play");

      $activeVideo.removeClass("video__content--active")[0].pause();
      $playButton.fadeIn(250);
    });
  },

  slider: function () {
    const slider_dom = $(".videos");
    if (slider_dom.length) {
      const nav_prev = slider_dom.find(".swiper-button-prev")[0];
      const nav_next = slider_dom.find(".swiper-button-next")[0];

      new Swiper(slider_dom[0], {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: -20,
        centeredSlides: true,
        slideToClickedSlide: true,
        initialSlide: 1,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
        navigation: {
          prevEl: nav_prev,
          nextEl: nav_next,
        },
        breakpoints: {
          450: {
            slidesPerView: 1.8,
            spaceBetween: -70,
            centeredSlides: true,
          },
        },
        on: {
          slideChange: function () {
            templateVideoGallery.closeAllVideos();
          },
        },
      });
    }
  },
};

export default templateVideoGallery;
